import { render, staticRenderFns } from "./coverage-details.vue?vue&type=template&id=0f83b1f6&scoped=true"
import script from "./coverage-details.vue?vue&type=script&lang=js"
export * from "./coverage-details.vue?vue&type=script&lang=js"
import style0 from "./coverage-details.vue?vue&type=style&index=0&id=0f83b1f6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f83b1f6",
  null
  
)

export default component.exports